export default {
  STREAM_STARTED: "STARTED",
  STREAM_STOPPED: "STOPPED",
};
